import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { t } from '../i18n';
import About from './About';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    password_confirm: '',
    first_name: '',
    last_name: '',
    description: '',
    contact_info: '',
  });
  const [error, setError] = useState('');
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.password_confirm) {
      setError(t('passwordsDoNotMatch'));
      return;
    }

    try {
      await register(formData);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || t('registrationFailed'));
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '50px auto' }}>
        <h2>{t('register')}</h2>
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('username')} *</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('email')} *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <small style={{ display: 'block', marginTop: '6px', fontStyle: 'italic', color: '#666' }} title={t('privateEmailExplanation')}>{t('yourEmailIsPrivate')}</small>
          </div>
          <div className="form-group">
            <label>{t('password')} *</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="8"
            />
          </div>
          <div className="form-group">
            <label>{t('confirmPassword')} *</label>
            <input
              type="password"
              name="password_confirm"
              value={formData.password_confirm}
              onChange={handleChange}
              required
              minLength="8"
            />
          </div>
          <div className="form-group">
            <label>{t('firstName')}</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>{t('lastName')}</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>{t('description')}</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder={t('tellPeopleAboutYourself')}
              maxLength={500}
            />
            <div style={{ textAlign: 'right', color: '#666', fontSize: '12px', marginTop: '6px' }}>{formData.description.length}/500</div>
          </div>
          <div className="form-group">
            <label>{t('whereToContactMe')}</label>
            <textarea
              name="contact_info"
              value={formData.contact_info}
              onChange={handleChange}
              placeholder={t('contactInfoPlaceholder')}
              maxLength={500}
            />
            <div style={{ textAlign: 'right', color: '#666', fontSize: '12px', marginTop: '6px' }}>{formData.contact_info.length}/500</div>
          </div>
          <button type="submit" className="btn btn-primary">{t('register')}</button>
        </form>
        <p style={{ marginTop: '20px' }}>
          {t('alreadyHaveAccount')} <a href="/login">{t('loginHere')}</a>
        </p>
      </div>
      <About />
    </div>
  );
};

export default Register;
